import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import type { SyncDisplayConfig } from './SyncStatus.types';

/**
 * To support a new API value, add the alias to the right group.
 * To add a new group, add one object.
 */
export const STATUS_GROUPS = [
  {
    aliases: ['synced', 'ok', 'success'],
    config: { icon: CheckCircleOutlineIcon, color: 'success', tooltipKey: 'syncStatus.synced' },
  },
  {
    aliases: ['not_synced', 'failed', 'error'],
    config: { icon: SyncProblemIcon, color: 'warning', tooltipKey: 'syncStatus.not_synced' },
  },
  {
    aliases: ['pending', 'in_progress'],
    config: { icon: SyncProblemIcon, color: 'warning', tooltipKey: 'syncStatus.pending' },
  },
  {
    // Instance lifecycle statuses (HOMCO-750)
    aliases: ['activated'],
    config: { icon: HowToRegIcon, color: 'success', tooltipKey: 'syncStatus.activated' },
  },
  {
    aliases: ['unregistered'],
    config: { icon: HourglassEmptyIcon, color: 'warning', tooltipKey: 'syncStatus.unregistered' },
  },
  {
    aliases: ['revoked'],
    config: { icon: LinkOffIcon, color: 'error', tooltipKey: 'syncStatus.revoked' },
  },
  {
    aliases: ['unknown'],
    config: { icon: HelpOutlineIcon, color: 'info', tooltipKey: 'syncStatus.unknown' },
  },
] as const satisfies readonly { aliases: readonly string[]; config: SyncDisplayConfig }[];

export type SyncStatus = (typeof STATUS_GROUPS)[number]['aliases'][number];

const STATUS_MAP: ReadonlyMap<string, SyncDisplayConfig> = new Map(
  STATUS_GROUPS.flatMap(({ aliases, config }) => aliases.map(alias => [alias, config] as const)),
);

const FALLBACK = STATUS_MAP.get('unknown')!;

export function resolveSyncDisplay(status?: string | null): SyncDisplayConfig {
  if (!status) return FALLBACK;
  return STATUS_MAP.get(status.toLowerCase()) ?? FALLBACK;
}
